import React from "react";
import { MARKET_POINTS, REASONS } from "../../mock/mockData";

const SectionHeading = ({ num, label, title, accent }) => (
  <div className="mb-10 md:mb-14">
    <div className="flex items-center gap-3 mb-5">
      <span className="mono text-[11px] uppercase tracking-widest px-3 py-1 brut-border bg-white">{num}</span>
      <span className="mono text-[11px] uppercase tracking-widest text-black/60">{label}</span>
      <div className="flex-1 h-[3px] bg-black" />
    </div>
    <h2 className="display font-bold text-[36px] sm:text-[56px] md:text-[80px] lg:text-[96px] leading-[0.9]">
      {title}
    </h2>
    {accent}
  </div>
);

const Market = () => {
  return (
    <>
      {/* Section 01 - Mercado */}
      <section id="mercado" className="border-t-[3px] border-black">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-24">
          <SectionHeading
            num="01"
            label="O Mercado"
            title={
              <>
                O <span className="italic font-normal">chumbo-ácido</span>
                <br />
                está a perder
                <br />
                a corrida.
              </>
            }
          />

          <div className="grid lg:grid-cols-[1fr_1.2fr] gap-10 lg:gap-16">
            <p className="text-[16px] md:text-[19px] leading-[1.5]">
              Em Portugal, <span className="mono px-1 bg-black text-white text-[14px]">Empresa A</span> e{" "}
              <span className="mono px-1 bg-black text-white text-[14px]">Empresa B</span> ainda têm quase toda
              a gama em chumbo-ácido — bateria pesada, fixa, com 6 meses de garantia.
              <br />
              <br />
              Na Veentto Vagos, o chumbo aparece apenas como{" "}
              <span className="bg-[#FFD60A] px-1 font-bold">comparativo</span>: tudo, do entrada de gama ao topo,
              vem exclusivamente em lítio.
            </p>

            <div className="grid sm:grid-cols-3 gap-5">
              {MARKET_POINTS.map((p, i) => {
                const bg =
                  p.tone === "red" ? "bg-[#E63946] text-white" :
                  p.tone === "yellow" ? "bg-[#FFD60A] text-black" :
                  "bg-black text-white";
                return (
                  <div key={i} className={`${bg} brut-border brut-card p-6 relative noise overflow-hidden`}>
                    <div className="display text-[40px] md:text-[52px] font-bold leading-none">{p.value}</div>
                    <div className="mt-3 text-[13px] leading-[1.4]">{p.label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Section 02 - Porque importa */}
      <section className="border-t-[3px] border-black bg-white">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-24">
          <SectionHeading
            num="02"
            label="Porque importa"
            title={
              <>
                Quatro razões pelas
                <br />
                quais{" "}
                <span className="italic font-normal underline decoration-[#E63946] decoration-[6px] underline-offset-[8px]">
                  o lítio fecha
                </span>
                <br />
                a venda.
              </>
            }
          />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-0 brut-border-thick">
            {REASONS.map((r, i) => (
              <div
                key={i}
                className={`p-7 md:p-8 ${i % 2 === 0 ? "bg-[#F4F0E8]" : "bg-white"} ${
                  i > 0 ? "border-t-[3px] lg:border-t-0 lg:border-l-[3px] border-black" : ""
                } ${i === 1 ? "sm:border-t-0 sm:border-l-[3px] sm:border-black" : ""} ${
                  i === 2 ? "sm:border-l-0 lg:border-l-[3px]" : ""
                }`}
              >
                <div className="display text-[64px] md:text-[80px] font-bold leading-none">{r.value}</div>
                <div className="mono text-[12px] uppercase tracking-widest mt-1 text-[#E63946] font-bold">
                  {r.unit}
                </div>
                <div className="mt-5 text-[14px] leading-[1.4]">{r.label}</div>
                <div className="mt-2 mono text-[11px] uppercase text-black/50">{r.vs}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Market;
